module.exports = __webpack_public_path__ + "static/media/insturctor8.6a22b370.png";